(() => {
  const CART_KEYS = Object.freeze({
    fbp: '_fbp',
    fbc: '_fbc',
    fbclid: '_fbclid',
    clickedAt: '_fbclid_timestamp',
  });
  const META_COOKIE = /^fb\.1\.\d+\.[A-Za-z0-9_-]+$/;
  const CLICK_ID = /^[A-Za-z0-9_-]{8,500}$/;
  const storage = window.localStorage;
  let syncing = null;

  function cookie(name) {
    const prefix = `${encodeURIComponent(name)}=`;
    const row = document.cookie.split('; ').find((item) => item.startsWith(prefix));
    return row ? decodeURIComponent(row.slice(prefix.length)) : '';
  }

  function rememberClick() {
    const value = new URL(window.location.href).searchParams.get('fbclid') || '';
    if (!CLICK_ID.test(value)) return;
    const clickedAt = String(Date.now());
    storage.setItem(CART_KEYS.fbclid, value);
    storage.setItem(CART_KEYS.clickedAt, clickedAt);
    const fbc = `fb.1.${clickedAt}.${value}`;
    storage.setItem(CART_KEYS.fbc, fbc);
    document.cookie = `${CART_KEYS.fbc}=${encodeURIComponent(fbc)}; path=/; max-age=7776000; SameSite=Lax; Secure`;
  }

  function identifiers() {
    const fbp = cookie(CART_KEYS.fbp);
    const fbc = cookie(CART_KEYS.fbc) || storage.getItem(CART_KEYS.fbc) || '';
    const fbclid = storage.getItem(CART_KEYS.fbclid) || '';
    const clickedAt = storage.getItem(CART_KEYS.clickedAt) || '';
    return {
      ...(META_COOKIE.test(fbp) ? { [CART_KEYS.fbp]: fbp } : {}),
      ...(META_COOKIE.test(fbc) ? { [CART_KEYS.fbc]: fbc } : {}),
      ...(CLICK_ID.test(fbclid) ? { [CART_KEYS.fbclid]: fbclid } : {}),
      ...(/^\d{13}$/.test(clickedAt) ? { [CART_KEYS.clickedAt]: clickedAt } : {}),
    };
  }

  function cartUrl(file) {
    const root = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    return `${root}cart/${file}`;
  }

  async function sync() {
    if (syncing) return syncing;
    syncing = (async () => {
      const attributes = identifiers();
      if (!Object.keys(attributes).length) return;
      const cartResponse = await fetch(cartUrl('js'), {
        credentials: 'same-origin',
        headers: { accept: 'application/json' },
      });
      if (!cartResponse.ok) return;
      const cart = await cartResponse.json();
      const changed = Object.entries(attributes).some(([key, value]) => cart.attributes?.[key] !== value);
      if (!changed) return;
      await fetch(cartUrl('update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify({ attributes }),
        keepalive: true,
      });
    })().catch(() => {}).finally(() => { syncing = null; });
    return syncing;
  }

  rememberClick();
  void sync();
  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    void sync();
    if (attempts >= 10 || (cookie(CART_KEYS.fbp) && cookie(CART_KEYS.fbc))) window.clearInterval(timer);
  }, 1_000);
  window.addEventListener('pageshow', () => void sync());
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') void sync();
  });
  document.addEventListener('submit', () => void sync(), true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[name="checkout"], a[href*="/checkout"]')) void sync();
  }, true);
})();
